import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {RenderedService} from '../../rendered.service';
import {BaseScaffoldComponent} from '../base-scaffold/base-scaffold.component';

/**
 * @fileoverview date and time range picker. can be bound to a property
 */
@Component({
  selector: "app-day-range-picker",
  templateUrl: "./day-range-picker.component.html",
  styleUrls: [
    "../../rendered.component.scss",
    "./day-range-picker.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayRangePickerComponent extends BaseScaffoldComponent implements OnInit, OnDestroy {
  private _selected = [];

  @ViewChild('selector', {static: true}) selector: ElementRef;

  week = [
    {label: 'S'}, {label: 'M'}, {label: 'T'}, {label: 'W'}, {label: 'T'}, {label: 'F'}, {label: 'S'},
  ];
  selected;
  selected_end;

  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();

  /**
   *
   * @param cdr
   * @param renderedService
   */

  constructor(public cdr: ChangeDetectorRef, public renderedService: RenderedService) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  selectDay(i) {
    if (this.checkDisable()) {
      return null;
    }
    if (this.selected === undefined) {
      this.selected = i;
    } else {
      if (i === this.selected) {
        if (this.selected_end) {
          this.selected = this.selected_end;
          this.selected_end = undefined;
        } else {
          this.selected = undefined;
        }
      } else if (i === this.selected_end) {
        this.selected_end = undefined;
      } else {
        if (i < this.selected) {
          if (!this.selected_end) {
            this.selected_end = this.selected;
          }
          this.selected = i;
        } else {
          this.selected_end = i;
        }
      }
    }
    this.updateValue();
  }

  update() {
    console.log("UPDATE DATE RANGE", this.value);
    if (this.value) {
      if (this.value.length === 0) {
        this.selected = undefined;
        this.selected_end = undefined;
      } else {
        this.value.sort();
        if (this.value.length > 0 && this.value[0] >= 0) {
          this.selected = this.value[0];
        }
        if (this.value.length > 1) {
          this.selected_end = this.value[this.value.length - 1];
        }
      }
    } else {
      console.log("resetting range");
      this._value = [];
      this.selected = undefined;
      this.selected_end = undefined;
    }
    console.log(this);
    this.cdr.detectChanges();
  }

  updateValue() {
    const _selected = [];
    if (this.selected >= 0) {
      _selected.push(this.selected);
    }
    if (this.selected_end >= this.selected) {
      for (let i = this.selected + 1; i <= this.selected_end; i++) {
        _selected.push(i);
      }
    }
    this.change.emit({value: _selected});

  }
}
